export default "__VITE_ASSET__BD0bD4LY__"